
import { PaymentInfo } from "@/types/payment.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { IDebitNegotiation } from "@/types/debits-negotiation.type";

const API_URL = `${import.meta.env.VITE_API_URL}/debits-negotiation`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export function negotiationDebits(data: Partial<IDebitNegotiation>) {
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}